<template>
    <div :class="{'note-list': true, 'note-list-unread': listitem.unreadCount > 0}" @click="navToContent">
        <span :class="{'note-list-pre': true, 'note-list-pre-unread': listitem.unreadCount > 0}">
            {{preTip}}
        </span>
        <span :class="{'note-list-title': true, 'note-list-title-unread': listitem.unreadCount > 0}">
            {{title}}
        </span>
        <span v-if="afterTip.length > 0" :class="{'note-list-after': true, 'note-list-after-unread': listitem.unreadCount > 0}">
            {{afterTip}}
        </span>
        <span class="note-list-tips"
        >(有<span :class="{'note-list-tips-number': listitem.unreadCount > 0}">{{listitem.unreadCount}}条</span>新回复)
        </span>
        <span class="note-list-time">{{listitem.time}}</span>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/user-center/note-list.less';
</style>

<script>
import {mapState} from 'vuex';
import {openNewWindow} from '@/utils/decorate/event';

export default {
    props: {
        listitem: {
            'type': Object,
            'default': {}
        }
    },
    computed: {
        ...mapState({
            isSwan: state => state.common.isSwan,
            swanPages: state => state.common.swanPages
        }),
        preTip: {
            get() {
                return this.listitem.type === 'TOPIC' ? '您发布的帖子:'
                    : (this.listitem.type === 'REPLY' ? '您回复的帖子:' : '您在');
            }
        },
        afterTip: {
            get() {
                return this.listitem.type === 'FLOOR_REPLY' ? '回复的楼层' : '';
            }
        },
        title: {
            get() {
                return this.listitem.topicIsDelete ? '原帖已删除' : this.listitem.title;
            }
        }
    },
    methods: {
        navToContent() {
            if (this.listitem.topicType === 3) {
                let issueid = this.listitem.issueId;
                if (this.isSwan) {
                    if (!this.listitem.topicIsDelete) {
                        openNewWindow(`${this.swanPages.issueContent}?issueid=${issueid}`);
                    }
                    return;
                }
                this.$router.push({name: 'issueContent', params: {issueid}});
                return;
            }
            let topicid = this.listitem.topicId;
            if (this.isSwan) {
                if (!this.listitem.topicIsDelete) {
                    openNewWindow(`${this.swanPages.topicContent}?topicid=${topicid}`);
                }
                return;
            }
            this.$router.push({name: 'topicContent', params: {topicid}});
        }
    }
};
</script>